export default "https://cdn-gra.amplement.io/statics/images/shortlogo.png";